export default {
      id: "bullet-arrow-left-usage",
      viewBox: "0 0 5 8",
      url: "/" + "img/marilyn-ui.svg#bullet-arrow-left",
      toString: function () {
        return this.url;
      }
    }